import {useCallback, useMemo} from "react";
import {useSelector} from "../../../__snowpack__/pkg/react-redux.js";
import {useAppDispatch} from "../store.js";
import {selectConfig, selectTheme} from "./white-label.selectors.js";
import {whiteLabelStore} from "./white-label.slice.js";
export function useReduxWhiteLabelTheme() {
  const dispatch = useAppDispatch();
  const state = useSelector(selectTheme);
  return [
    useMemo(() => state, [state]),
    useCallback((newState) => {
      dispatch(whiteLabelStore.actions.setTheme(newState));
    }, [dispatch]),
    useCallback(() => {
      dispatch(whiteLabelStore.actions.resetTheme());
    }, [dispatch])
  ];
}
export function useReduxWhiteLabelConfig() {
  const dispatch = useAppDispatch();
  const state = useSelector(selectConfig);
  return [
    useMemo(() => state, [state]),
    useCallback((newState) => {
      dispatch(whiteLabelStore.actions.setConfiguration(newState));
    }, [dispatch]),
    useCallback(() => {
      dispatch(whiteLabelStore.actions.resetConfiguration());
    }, [dispatch])
  ];
}
